var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.can("workshops.view_field_is_sensitive_workshop"))?_c('b-badge',{staticClass:"custom-font-size",attrs:{"pill":"","variant":"info"}},[_vm._v("Gevoelig om snel gedateerd te zijn")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }